import {
  ADD_NEW_LIST,
  ADD_NEW_LIST_FAILED,
  ADD_NEW_LIST_SUCCESS,
  COPY_LIST,
  COPY_LIST_FAILED,
  COPY_LIST_SUCCESS,
  DELETE_LIST_ITEM,
  DELETE_LIST_ITEM_FAILED,
  DELETE_LIST_ITEM_SUCCESS,
  GET_EXPERIENCES,
  GET_EXPERIENCES_FAILED,
  GET_EXPERIENCES_LIST,
  GET_EXPERIENCES_LIST_FAILED,
  GET_EXPERIENCES_LIST_SUCCESS,
  GET_EXPERIENCES_SUCCESS,
  GET_LIST_FEATURE,
  GET_LIST_FEATURE_FAILED,
  GET_LIST_FEATURE_SUCCESS,
  GET_LIST_ITEM,
  GET_LIST_ITEM_CLICKS,
  GET_LIST_ITEM_CLICKS_FAILED,
  GET_LIST_ITEM_CLICKS_SUCCESS,
  GET_LIST_ITEM_FAILED,
  GET_LIST_ITEM_SUCCESS,
  GET_LIST_OF_LISTS,
  GET_LIST_OF_LISTS_FAILED,
  GET_LIST_OF_LISTS_SUCCESS,
  HIDE_COPY_LIST_MODAL,
  HIDE_DELETE_LIST_MODAL,
  HIDE_LIST_ITEM_POPUP,
  OPEN_COPY_LIST_MODAL,
  OPEN_DELETE_LIST_MODAL,
  OPEN_LIST_ITEM_POPUP,
  RESET_LIST_FEATURE,
  RESET_LIST_ITEM,
  RESET_LIST_ITEM_CLICKS,
  RESET_LIST_OF_LISTS,
  UPDATE_LIST,
  UPDATE_LIST_FAILED,
  UPDATE_LIST_FEATURE,
  UPDATE_LIST_FEATURE_FAILED,
  UPDATE_LIST_FEATURE_SUCCESS,
  UPDATE_LIST_ORDER,
  UPDATE_LIST_ORDER_FAILED,
  UPDATE_LIST_ORDER_SUCCESS,
  UPDATE_LIST_SUCCESS,
} from "./actionTypes"

export const openListItemPopup = () => ({
  type: OPEN_LIST_ITEM_POPUP,
  payload: {},
})

export const hideListItemPopup = () => ({
  type: HIDE_LIST_ITEM_POPUP,
  payload: {},
})

export const addNewList = params => ({
  type: ADD_NEW_LIST,
  payload: params,
})

export const addNewListSuccess = response => ({
  type: ADD_NEW_LIST_SUCCESS,
  payload: response,
})

export const addNewListFailed = error => ({
  type: ADD_NEW_LIST_FAILED,
  payload: error,
})

export const getListOfLists = params => ({
  type: GET_LIST_OF_LISTS,
  payload: params,
})

export const getListOfListsSuccess = response => ({
  type: GET_LIST_OF_LISTS_SUCCESS,
  payload: response,
})

export const getListOfListsFailed = error => ({
  type: GET_LIST_OF_LISTS_FAILED,
  payload: error,
})

export const openCopyListModal = () => ({
  type: OPEN_COPY_LIST_MODAL,
  payload: {},
})

export const hideCopyListModal = () => ({
  type: HIDE_COPY_LIST_MODAL,
  payload: {},
})

export const getExperiences = () => ({
  type: GET_EXPERIENCES,
  payload: {},
})

export const getExperiencesSuccess = response => ({
  type: GET_EXPERIENCES_SUCCESS,
  payload: response,
})

export const getExperiencesFailed = error => ({
  type: GET_EXPERIENCES_FAILED,
  payload: error,
})

export const getExperiencesList = params => ({
  type: GET_EXPERIENCES_LIST,
  payload: params,
})

export const getExperiencesListSuccess = response => ({
  type: GET_EXPERIENCES_LIST_SUCCESS,
  payload: response,
})

export const getExperiencesListFailed = error => ({
  type: GET_EXPERIENCES_LIST_FAILED,
  payload: error,
})

export const getListFeature = params => ({
  type: GET_LIST_FEATURE,
  payload: params,
})

export const getListFeatureSuccess = response => ({
  type: GET_LIST_FEATURE_SUCCESS,
  payload: response,
})

export const getListFeatureFailed = error => ({
  type: GET_LIST_FEATURE_FAILED,
  payload: error,
})

export const resetListFeature = () => ({
  type: RESET_LIST_FEATURE,
  payload: {},
})

export const updateList = params => ({
  type: UPDATE_LIST,
  payload: params,
})

export const updateListSuccess = response => ({
  type: UPDATE_LIST_SUCCESS,
  payload: response,
})

export const updateListFailed = error => ({
  type: UPDATE_LIST_FAILED,
  payload: error,
})

export const deleteListItem = params => ({
  type: DELETE_LIST_ITEM,
  payload: params,
})

export const deleteListItemSuccess = response => ({
  type: DELETE_LIST_ITEM_SUCCESS,
  payload: response,
})

export const deleteListItemFailed = error => ({
  type: DELETE_LIST_ITEM_FAILED,
  payload: error,
})

export const openDeleteListModal = () => ({
  type: OPEN_DELETE_LIST_MODAL,
  payload: {},
})

export const hideDeleteListModal = () => ({
  type: HIDE_DELETE_LIST_MODAL,
  payload: {},
})

export const updateListFeature = params => ({
  type: UPDATE_LIST_FEATURE,
  payload: params,
})

export const updateListFeatureSuccess = response => ({
  type: UPDATE_LIST_FEATURE_SUCCESS,
  payload: response,
})

export const updateListFeatureFailed = error => ({
  type: UPDATE_LIST_FEATURE_FAILED,
  payload: error,
})

export const copyList = params => ({
  type: COPY_LIST,
  payload: params,
})

export const copyListSuccess = response => ({
  type: COPY_LIST_SUCCESS,
  payload: response,
})

export const copyListFailed = error => ({
  type: COPY_LIST_FAILED,
  payload: error,
})

export const updateListOrder = params => ({
  type: UPDATE_LIST_ORDER,
  payload: params,
})

export const updateListOrderSuccess = response => ({
  type: UPDATE_LIST_ORDER_SUCCESS,
  payload: response,
})

export const updateListOrderFailed = error => ({
  type: UPDATE_LIST_ORDER_FAILED,
  payload: error,
})

export const resetListOfLists = () => ({
  type: RESET_LIST_OF_LISTS,
  payload: {},
})

export const getListItem = params => ({
  type: GET_LIST_ITEM,
  payload: params,
})

export const getListItemSuccess = response => ({
  type: GET_LIST_ITEM_SUCCESS,
  payload: response,
})

export const getListItemFailed = error => ({
  type: GET_LIST_ITEM_FAILED,
  payload: error,
})

export const resetListItem = () => ({
  type: RESET_LIST_ITEM,
  payload: {},
})

export const getListItemClicks = params => ({
  type: GET_LIST_ITEM_CLICKS,
  payload: params,
})

export const getListItemClicksSuccess = response => ({
  type: GET_LIST_ITEM_CLICKS_SUCCESS,
  payload: response,
})

export const getListItemClicksFailed = error => ({
  type: GET_LIST_ITEM_CLICKS_FAILED,
  payload: error,
})

export const resetListItemClicks = () => ({
  type: RESET_LIST_ITEM_CLICKS,
  payload: {},
})
